import Section from "../../layout/Section/Section";
import Button from "../../ui/Button/Button";
import { teaser, teaserFooter } from "../../../data/pricingTeaser";
import styles from "./PricingTeaser.module.css";

const icons = {
  pulse: <path d="M3 12h4l2.5-6 4 12 2.5-6H21" />,
  code: <path d="M8 7 3 12l5 5M16 7l5 5-5 5M13.5 4 10.5 20" />,
  pin: (
    <>
      <path d="M12 21s7-6 7-12a7 7 0 1 0-14 0c0 6 7 12 7 12Z" />
      <circle cx="12" cy="9" r="2.4" />
    </>
  ),
  check: <path d="m5 12.5 4 4L19 7" />,
  arrow: <path d="M5 12h14m-5-5 5 5-5 5" />,
};

function Icon({ name, size = 22 }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {icons[name]}
    </svg>
  );
}

const toNumber = (value) => Number(String(value).replace(/[^\d.]/g, ""));

function discountPercent(price, originalPrice) {
  const now = toNumber(price);
  const was = toNumber(originalPrice);
  if (!now || !was || was <= now) return null;
  return Math.round(((was - now) / was) * 100);
}

export default function PricingTeaser() {
  return (
    <Section
      id="pricing"
      eyebrow="Clear pricing. Real possibilities."
      title="Your next step, at the right price."
      subtitle="Start with what your business needs today. Build on it when you’re ready."
      bg="muted"
    >
      <div className={styles.grid}>
        {teaser.map((plan) => {
          const off = discountPercent(plan.price, plan.originalPrice);
          return (
            <article
              key={plan.id}
              className={`${styles.plan} ${plan.featured ? styles.featured : ""}`}
              data-reveal=""
            >
              <div className={styles.topline}>
                <span className={styles.icon}>
                  <Icon name={plan.icon} />
                </span>
                {plan.featured && <span className={styles.tag}>Most popular</span>}
              </div>
              <div className={styles.head}>
                <h3 className={styles.name}>{plan.name}</h3>
                <p className={styles.tagline}>{plan.tagline}</p>
              </div>

              <div className={styles.pricing}>
                <span className={styles.priceLabel}>{plan.priceLabel}</span>
                <div className={styles.priceRow}>
                  <span className={styles.price}>{plan.price}</span>
                  {plan.originalPrice && <s className={styles.was}>{plan.originalPrice}</s>}
                </div>
                {off && <span className={styles.save}>Save {off}%</span>}
              </div>

              <ul className={styles.points}>
                {plan.points.map((point) => (
                  <li key={point}>
                    <span className={styles.check}>
                      <Icon name="check" size={15} />
                    </span>
                    {point}
                  </li>
                ))}
              </ul>

              <Button
                href={plan.cta.href}
                fullWidth
                variant={plan.featured ? "primary" : "secondary"}
                className={styles.button}
              >
                {plan.cta.label}
                <Icon name="arrow" size={18} />
              </Button>
            </article>
          );
        })}
      </div>

      <ul className={styles.footer}>
        {teaserFooter.map((item) => (
          <li key={item}><Icon name="check" size={15} />{item}</li>
        ))}
      </ul>
    </Section>
  );
}
